"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogLevels;
(function (LogLevels) {
    LogLevels["log"] = "log";
    LogLevels["debug"] = "debug";
    LogLevels["info"] = "info";
    LogLevels["warn"] = "warn";
    LogLevels["error"] = "error";
})(LogLevels = exports.LogLevels || (exports.LogLevels = {}));
